import { extendTheme } from "@chakra-ui/react";

const chakraTheme = extendTheme({
  colors: {
    brand: {
      50: "#f0f4ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
    },
  },
  components: {
    Card: {
      baseStyle: {
        container: {
          borderRadius: "lg",
          boxShadow: "md",
          _hover: {
            boxShadow: "lg",
            transform: "translateY(-2px)",
          },
          transition: "all 0.2s",
        },
      },
    },
    Badge: {
      baseStyle: {
        textTransform: "uppercase",
        fontSize: "xs",
        fontWeight: "600",
      },
    },
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === "dark" ? "gray.900" : "white",
        color: props.colorMode === "dark" ? "white" : "gray.800",
      },
    }),
  },
});

export default chakraTheme;
